// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q8nO","largestCol":"styles_largestCol__1oed2","smallestCol":"styles_smallestCol__2eSLd"};